import { Box, useTheme, withStyles } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { CustomDialogIcon } from '@setvi/shared/components/sdialogs/sconfirm/icons';
import { TypeColor } from '@setvi/shared/components/sdialogs/sconfirm/helper';

const StyledButton = withStyles({
  root: {
    borderRadius: 120
  }
})(SButton);

interface ConfirmationProps {
  title: string;
  description?: string;
  additionalContent?: string;
  confirmText?: string;
  cancelText?: string;
  icon?: JSX.Element;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CancelConfirmation = ({
  title,
  icon,
  description,
  additionalContent,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onCancel,
  onConfirm
}: ConfirmationProps) => {
  const { palette } = useTheme();

  return (
    <Box p={2}>
      <Box display="flex" alignItems="center" gridGap="8px" mb="12px">
        {icon || (
          <CustomDialogIcon
            stroke={TypeColor.delete}
            viewBox="0 0 46 46"
            style={{ width: 46, height: 46, fill: 'none' }}
          />
        )}
        <SText title={title} noLineClamp size="lg" weight="semibold" />
      </Box>
      {description && (
        <SText
          size="sm"
          title={description}
          fontColor={TextColor.SlateGrey}
          noLineClamp
        />
      )}
      {additionalContent && (
        <Box mt={3}>
          <SText size="sm" title={additionalContent} noLineClamp />
        </Box>
      )}
      <Box display="flex" gridGap={16} mt={5}>
        <StyledButton
          fullWidth
          style={{ backgroundColor: palette.error.main }}
          onClick={onConfirm}>
          {confirmText}
        </StyledButton>
        <StyledButton
          fullWidth
          variant="outlined"
          color="inherit"
          onClick={onCancel}>
          {cancelText}
        </StyledButton>
      </Box>
    </Box>
  );
};
